export default __webpack_public_path__ + "static/media/promo_01.9dee7045.jpg";